import { Tool } from './Tool'
import { DragRotate, PinchRotate, Select, Translate } from 'ol/interaction'
import { altKeyOnly } from 'ol/events/condition'

export default class MoveTool extends Tool {
    private selectInteraction!: Select;
    private translateInteraction!: Translate;
    private rotateInteraction!: PinchRotate;

    public removeInteractions(): void {
        if (this.selectInteraction) { this.state.map?.removeInteraction(this.selectInteraction) }
        if (this.translateInteraction) { this.state.map?.removeInteraction(this.translateInteraction) }
    }

    public addInteractions(): void {
        this.selectInteraction = new Select({})
        this.translateInteraction = new Translate({
            features: this.selectInteraction.getFeatures()
        })
        this.rotateInteraction = new PinchRotate()

        this.state.map?.addInteraction(this.rotateInteraction)
        this.state.map?.addInteraction(this.selectInteraction)
        this.state.map?.addInteraction(this.translateInteraction)

        this.translateInteraction.on('translatestart', (evt) => {
            evt.features.forEach((feature) => {
                this.tooltipManager.removeToolTip(feature)
            })
        })

        this.translateInteraction.on('translateend', (evt) => {
            evt.features.forEach((feature) => {
                this.tooltipManager.createFixedToolTip(feature)
            })
        })
    }
}
